import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * The call's ownership as the browser shows it (Q-2492 slice 2). isOwner is derived from calls.owner_id (=== the signed-in
 * user's id) by useCallOwnershipSync, from the row and its realtime updates. A call-state claim or heartbeat response
 * never sets it: the writer lease those grant is a separate per-tab flag inside useCallStateSync.
 */
interface CallOwnershipState {
  ownerId: string | null;
  ownerName: string | null;
  isOwner: boolean;
  claimedAt: number | null;
  updatedAt: number | null;
}

const initialState: CallOwnershipState = {
  ownerId: null,
  ownerName: null,
  isOwner: false,
  claimedAt: null,
  updatedAt: null,
};

const callOwnershipSlice = createSlice({
  name: 'callOwnership',
  initialState,
  reducers: {
    setCallOwnership: (state, action: PayloadAction<{
      ownerId: string | null;
      ownerName?: string | null;
      isOwner: boolean;
      claimedAt?: number | null;
      updatedAt?: number;
    }>) => {
      state.ownerId = action.payload.ownerId;
      state.ownerName = action.payload.ownerName ?? state.ownerName;
      state.isOwner = action.payload.isOwner;
      state.claimedAt = action.payload.claimedAt ?? state.claimedAt;
      state.updatedAt = action.payload.updatedAt ?? Date.now();
    },
    /**
     * Show call ownership from the calls row (useCallOwnershipSync: the mount load,
     * a reconnect re-sync and every realtime row update).
     */
    hydrateCallOwnership: (state, action: PayloadAction<{
      ownerId: string | null;
      ownerName: string | null;
      isOwner: boolean;
      claimedAt: number | null;
      updatedAt?: number;
    }>) => {
      state.ownerId = action.payload.ownerId;
      state.ownerName = action.payload.ownerName;
      state.isOwner = action.payload.isOwner;
      state.claimedAt = action.payload.claimedAt;
      state.updatedAt = action.payload.updatedAt ?? Date.now();
    },
    clearCallOwnership: () => initialState,
  },
});

export const { setCallOwnership, hydrateCallOwnership, clearCallOwnership } = callOwnershipSlice.actions;
export default callOwnershipSlice.reducer;
